export const discoveryTasks = {
  en: {
    pageTitle: 'Disabled Discovery Tasks',
    empty: {
      heading: 'All discovery tasks will be processed',
      btnCreate: 'Disable specific tasks',
    },
    list: {
      boxTitle: 'Defined rules',
      btnAdd: 'Add rule',
      btnDelete: 'Delete',
      taskId: 'Task',
      label: 'Note',
      action: 'Action',
      deleteConfirmDialog: {
        header: 'Discovery task will be deleted',
        subHeader: 'Do you really want to delete discovery task?',
        btnConfirm: 'Delete',
        btnSecondaryConfirm: 'Cancel',
      },
    },
    detail: {
      resultsTitle: 'Results',
      resultsDescription: 'List of devices that meets the rules',
      btnCreate: 'Create',
      btnSave: 'Save',
      btnCancel: 'Cancel',
      noResults: 'No results match the rules',
      form: {
        taskId: 'Task',
        label: 'Note',
        vendor: 'Vendor',
        family: 'Family',
        platform: 'Platform',
        model: 'Model',
        version: 'Version',
        sn: 'Serial number',
        regexRules: 'Regex rules',
        btnTestRules: 'Test rules',
        validation: {
          required: 'Field is required',
          invalidRegExp: 'Invalid regular expression',
          missingRegExp: 'At least 1 rule must be specified',
        },
      },
    },
    request: {
      taskCreated: 'Task created',
      taskUpdated: 'Task updated',
      taskDeleted: 'Task deleted',
      selectedTasksDeleted: 'Selected tasks deleted',
    },
  },
};
